import * as XLSX from "xlsx";

import type { Account } from "~/types/contabilidad";

export const BUDGET_MONTH_HEADERS = [
  "Ene",
  "Feb",
  "Mar",
  "Abr",
  "May",
  "Jun",
  "Jul",
  "Ago",
  "Sep",
  "Oct",
  "Nov",
  "Dic",
];

/**
 * Generate and download a budget import template, prefilled with the
 * company's eligible accounts (ingreso/gasto) and empty month cells.
 */
export function downloadBudgetTemplate(
  accounts: Account[],
  companyName: string,
  fiscalYear: number
): void {
  const wb = XLSX.utils.book_new();

  // Instructions sheet
  const instructions = [
    ["INSTRUCCIONES PARA IMPORTAR PRESUPUESTO"],
    [""],
    ["1. FORMATO DEL ARCHIVO:"],
    ["   - Use la hoja 'Presupuesto' para ingresar los montos"],
    ["   - La validación usa solo el Código; la columna Cuenta es referencial"],
    ["   - Guarde el archivo como Excel (.xlsx) o CSV"],
    [""],
    ["2. CÓMO INGRESAR LOS MONTOS:"],
    ["   - Use los signos del estado de resultados: ingresos en POSITIVO y"],
    ["     costos/gastos en NEGATIVO (ej: Ventas 120.000.000,"],
    ["     Remuneraciones -25.000.000)"],
    ["   - El resultado del presupuesto es la suma algebraica de los montos"],
    ["   - Las celdas vacías se consideran 0"],
    ["   - Use un monto por cuenta y mes, en pesos chilenos"],
    [""],
    ["3. NOTAS IMPORTANTES:"],
    ["   - Solo se aceptan cuentas de tipo ingreso o gasto de la empresa"],
    ["   - Los códigos desconocidos o duplicados serán rechazados"],
    ["   - La importación REEMPLAZA el presupuesto completo"],
  ];

  const instructionsSheet = XLSX.utils.aoa_to_sheet(instructions);
  instructionsSheet["!cols"] = [{ wch: 70 }];
  XLSX.utils.book_append_sheet(wb, instructionsSheet, "Instrucciones");

  // Data sheet prefilled with eligible accounts
  const data: (string | number)[][] = [
    ["Codigo", "Cuenta", ...BUDGET_MONTH_HEADERS],
    ...accounts.map((account) => [account.code, account.name]),
  ];

  const dataSheet = XLSX.utils.aoa_to_sheet(data);
  dataSheet["!cols"] = [
    { wch: 15 },
    { wch: 40 },
    ...BUDGET_MONTH_HEADERS.map(() => ({ wch: 14 })),
  ];
  XLSX.utils.book_append_sheet(wb, dataSheet, "Presupuesto");

  const filename = `plantilla_presupuesto_${companyName
    .toLowerCase()
    .replace(/\s+/g, "_")}_${fiscalYear}.xlsx`;

  XLSX.writeFile(wb, filename);
}
